<template>
<router-view></router-view>
</template>

<script>
/* eslint-disable no-unused-vars */

import BriefOverview from './BriefsOverview'
import BriefContent from './brief-content/index'

/**
   * this component is simple host for {@link BriefOverview} and {@link BriefContent} components
   */
export default {
  name: 'ContentBriefs'
}
</script>

<style scoped>

</style>
